
import Http from './http';

import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';

export const { Subjectivism, Nihilism } = _getGenerators();

export const CARTS   = new Subjectivism('clfinder', 'carts');
export const SHOWS   = new Nihilism('clfinder/shows');
export const SEARCH  = new Subjectivism('clfinder/search');
export const CLIPS   = new Subjectivism('clfinder', 'clips');
export const EPISODES   = new Subjectivism('clfinder', 'episodes');
export const TIMEDATA   = new Subjectivism('clfinder', 'timedata');
export const METADATA   = new Subjectivism('clfinder', 'metadata');
export const FACES_JOBS = new Subjectivism('clfinder', 'jobs');
export const HEARTBEAT  = new Nihilism('heartbeat');
export const FACES_JOB_STATUSES  = new Subjectivism('clfinder', 'jobs/status');
export const TAC        = new Nihilism('tac');


export const LOGS          = new Nihilism('logs');
export const ASSET_FLOW    = new Nihilism('asset-flow');
export const ASSET_RULES   = new Nihilism('asset-rules');
export const ASSET_FILE_CLOAK = new Nihilism('file-cloak');
export const ASSET_AUDIO_MAP  = new Nihilism('audio-map');
export const USERS         = new Nihilism('guard/users');


export const createFacetsGenerator = type => new Subjectivism('clfinder/search', type);

let _eid = '';

export default class CrudAPI {
   constructor(generator) {
      if ( !isFunction(generator.makePath) ) {
         throw new Error('Incorrect param');
      }
      this._pathGenerator = generator;
   }
   load(params) {
      return Http.get(this._path, { params });
   }
   get(id) {
      return Http.get(`${this._path}/${id}`);
   }
   save(item, { forcePost } = {}) {
      if (item.id && !forcePost ) {
         return Http.put(`${this._path}/${item.id}`, item);
      } else if (forcePost) {
         return Http.post(`${this._path}/${item.id}`, item);
      }
      return Http.post(this._path, item);
   }
   remove(item, params) {
      const id = isObject(item) ? item.id : item;
      return Http.delete(`${this._path}/${id}`, { params });
   }
   get _path() {
      return this._pathGenerator.makePath();
   }

   static setEpisodeId(eid) {
      _eid = eid;
   }
}

function _getGenerators() {
   class Subjectivism {
      constructor(service, subpath = '') {
         this.service = service;
         this.subpath = subpath;
      }

      makePath() {
         let res = `/${this.service}/shows/${_eid}`;
         res = this.subpath ? `${res}/${this.subpath}` : res;
         return res;
      }
   }

   class Nihilism {
      constructor(path) {
         this.path = path;
      }

      makePath() {
         return `/${this.path}`;
      }
   }

   return { Nihilism, Subjectivism };
}

